import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { InfoBarComponent } from '@app/shared/info-bar/info-bar.component';
import { CreateExamComponent } from './components/create-exam/create-exam.component';
import { ExamCardComponent } from './components/exam-card/exam-card.component';
import { ImageDatabaseComponent } from './components/image-database/image-database.component';

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [
    RouterOutlet,
    ExamCardComponent,
    CommonModule,
    InfoBarComponent,
    ImageDatabaseComponent,
    CreateExamComponent,
  ],
  templateUrl: './main-page.component.html',
  styleUrl: './main-page.component.scss',
})
export class MainPageComponent {
  constructor(private router: Router) {}

  handleMyExamsSelected(): void {
    this.router.navigate(['']);
  }

  handleDiscussionSelected(): void {
    this.router.navigate(['discussion']);
  }

  handleDatabaseSelected(): void {
    this.router.navigate(['database']);
  }

  handleCreateExam(): void {
    this.router.navigate(['create_exam']);
  }

  handleUserManagement(): void {
    this.router.navigate(['user_management']);
  }

  handleIntegrationLog(): void {
    this.router.navigate(['integration_log']);
  }

  handleMonitorExams(): void {
    this.router.navigate(['monitor_case']);
  }
}
